import { useAuthQuery } from 'hooks';
import { TCPlayer } from 'types';

export const useTCStep = (stageId: number) => {
  return useAuthQuery<TCPlayer[]>(['trading-comparables', stageId, 'players']);
};
